import React from "react";
import { ArrowUpRight } from "lucide-react";
import { appUrl } from "@/lib/referral";

const APP_SIGNUP = "https://work.voxiumscript.com";

export const PitchMeeting = () => {
  return (
    <section
      className="relative w-full bg-ink overflow-hidden"
      data-testid="pitch-meeting-section"
    >
      {/* Faint gold hairline ornament — single horizontal line, top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-20 bg-gold/40 hidden sm:block" aria-hidden="true" />

      {/* Faint corner ornaments — gold dots */}
      <div className="absolute top-10 left-10 hidden lg:flex flex-col gap-2 opacity-50">
        <span className="block w-1 h-1 rounded-full bg-gold" />
        <span className="block w-1 h-1 rounded-full bg-gold/60" />
      </div>
      <div className="absolute bottom-10 right-10 hidden lg:flex flex-col gap-2 opacity-50">
        <span className="block w-1 h-1 rounded-full bg-gold/60" />
        <span className="block w-1 h-1 rounded-full bg-gold" />
      </div>

      <div className="relative max-w-[60rem] mx-auto px-6 sm:px-10 lg:px-16 py-28 sm:py-36 lg:py-44 text-center">
        {/* Eyebrow */}
        <p className="eyebrow text-gold mb-8 sm:mb-10" data-testid="pitch-eyebrow">
          Rehearse the room before you walk in
        </p>

        {/* Headline — larger than primary cards to signal differentiator */}
        <h2
          className="display-serif text-creamtext text-5xl sm:text-6xl lg:text-[4.5rem] leading-[1.02] mb-10 sm:mb-12"
          data-testid="pitch-headline"
        >
          Pitch Meeting <br className="hidden sm:block" />
          <span className="italic font-light text-gold">Simulation</span>
        </h2>

        {/* Body */}
        <p
          className="font-body text-creamtext/85 text-lg sm:text-xl leading-relaxed max-w-prose3 mx-auto mb-8"
          data-testid="pitch-body"
        >
          The room is unforgiving. Voxium Script&apos;s pitch meeting simulation puts you across
          from a Producer, an Executive Producer, and a Director. You pitch — text, deck,
          treatment, or all three. They respond like they would in a real meeting. They ask
          the questions you&apos;ll be asked. They tell you how the project reads to them, and
          where they would push back.
        </p>

        {/* Frame — this is a room reaction, not a market prediction. */}
        <p
          className="font-body italic text-creamtext/70 text-base sm:text-lg max-w-prose3 mx-auto mb-6 sm:mb-8"
          data-testid="pitch-frame"
        >
          An emulation of an industry-standard verdict — a gauge of where your project
          stands against the room, not a guarantee of a sale. Every producer is different.
        </p>

        {/* Closing beat — kept short, no superlative. */}
        <p
          className="font-body italic text-creamtext/85 text-lg sm:text-xl max-w-prose3 mx-auto mb-12 sm:mb-14"
          data-testid="pitch-closing"
        >
          Pitch before you pitch.
        </p>

        {/* CTA — uses the same .btn-gold class as Hero and Pricing.
            Gold hex is identical (#C9A961). The button reads as brighter here
            because of dark-bg contrast — that's intentional for the
            differentiator section. Decision, not drift. */}
        <a
          href={appUrl(APP_SIGNUP)}
          className="btn-gold"
          data-testid="pitch-cta"
        >
          Try a pitch simulation
          <ArrowUpRight size={16} strokeWidth={2} />
        </a>
      </div>
    </section>
  );
};

export default PitchMeeting;
